import { cva } from 'class-variance-authority';

export const heroPhotoPositionVariants = cva('size-full object-cover', {
	variants: {
		position: {
			top: 'object-top',
			center: 'object-center',
			bottom: 'object-bottom'
		}
	},
	defaultVariants: {
		position: 'center'
	}
});

export { default as CuratedListHeroSection } from './HeroSection.vue';
